module.exports = __webpack_public_path__ + "static/media/creditNotEligible.b6e4060e.svg";